import React, { FunctionComponent, useMemo } from 'react';
import {
  Interchange,
  InterchangeDouble,
  InterchangeDoubleMobile,
  InterchangeMobile,
} from '@lt/components/icons-react/checkout-flight-ticket';
import { Time, Wrapper } from './FlightInterchange.style';
import { getFormattedDuration } from '../../../../utils';

type Props = {
  /**
   * время в дороге, передавать в секундах.
   * пример: 20400 -> 5ч 40м
   * */
  time: number;
  /** перелет прямой? */
  direct?: boolean;
  isMobile?: boolean;
  className?: string;
  iconWidth?: number;
};

export const FlightInterchange: FunctionComponent<Props> = ({
  time,
  direct,
  isMobile,
  className,
  iconWidth,
}) => {
  const Label = useMemo(() => {
    const formattedTime = getFormattedDuration(time, 'м');
    if (isMobile) {
      return formattedTime;
    }

    return `всего ${formattedTime}`;
  }, [isMobile, time]);

  const Icon = useMemo(() => {
    if (isMobile) {
      return direct ? InterchangeMobile : InterchangeDoubleMobile;
    }
    return direct ? Interchange : InterchangeDouble;
  }, [direct, isMobile]);

  const _iconWidth = useMemo(() => (iconWidth || isMobile ? 100 : 140), [iconWidth, isMobile]);

  return (
    <Wrapper className={className}>
      <Time>{Label}</Time>

      <Icon width={_iconWidth} />
    </Wrapper>
  );
};
